export default __webpack_public_path__ + "static/media/tuhfahAdmin.beedfe0e.png";